var C = {};

C.TILE_LAYER = "tile";
C.VECTOR_LAYER = "vector";
C.OMS_VECTOR_LAYER = "oms_vector";
C.OMS_CATEGORY_LAYER = "oms_vector_category";
C.OMS_CHARTS_LAYER = "oms_chart_layer";
C.OMS_VECTOR_FEATURE_LAYER = "oms_vector_feature";
C.OMS_MVT_LAYER = "oms_mvt";

C.TILE_LAYER_IDS = {};
C.TILE_LAYER_IDS[C.TILE_LAYER] = 0;

C.VECTOR_LAYER_IDS = {};
C.VECTOR_LAYER_IDS[C.VECTOR_LAYER] = 1;
C.VECTOR_LAYER_IDS[C.OMS_VECTOR_LAYER] = 2;
C.VECTOR_LAYER_IDS[C.OMS_CATEGORY_LAYER] = 3;
C.VECTOR_LAYER_IDS[C.OMS_CHARTS_LAYER] = 4;

C.BASES_TYPES = [
    'OMS',
    'PUBLIC_SERVICE',
    'XYZ',
    'WMS'
];

C.CONT_TYPES = {
    'map': 1,
    'folder': 2,
    'layers': 3,
    'virtual': 4,
    'raster': 5,
    'material': 7
};

module.exports = C;



//////////////////
// WEBPACK FOOTER
// ./src/consts.js
// module id = 18
// module chunks = 0